module.exports = "https://coursera_assets.s3.amazonaws.com/images/7ee43090ab129b1ca83386e73a17da80.png";